import React from 'react'
import Image from '@components/Image'
import Section from '@page-components/CheckoutV3/components/Section'

export default function CartSkeleton() {
  return (
    <Section
      compact
      icon={<Image alt="Cart icon" width={29} height={29} src="/images/icons/cart.svg" />}
      noPill
      subsection={
        <div className="py-3 animate-pulse">
          <div className="h-6 w-60 bg-gray-200 dark:bg-zinc-600"></div>
        </div>
      }>
      <div className="animate-pulse">
        <div className="flex">
          <div className="pl-2 flex-1">
            <div className="h-8 w-40 bg-gray-200 dark:bg-zinc-600 rounded"></div>
          </div>
          <div className="w-28">
            <div className="h-8 w-full bg-gray-200 dark:bg-zinc-600 rounded"></div>
          </div>
        </div>
      </div>
    </Section>
  )
}
